export const PAGEBUILDER_SHOW_POPUP = 'PAGEBUILDER.SHOW_POPUP';
export const PAGEBUILDER_CLOSE_POPUP = 'PAGEBUILDER.CLOSE_POPUP';
export const PAGEBUILDER_NAVIGATION_SHOW_POPUP = 'PAGEBUILDER.NAVIGATION_SHOW_POPUP';
export const PAGEBUILDER_NAVIGATION_CLOSE_POPUP = 'PAGEBUILDER.NAVIGATION_CLOSE_POPUP';
